function IconPinterest() {
  return (
    <svg
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1024"
      height="1024"
      viewBox="0 0 1024 1024"
    >
      <g id="icomoon-ignore" />
      <path
        fill="currentColor"
        d="M189.531 511.978c0 131.043 79.402 243.603 193.032 293.101-0.902-22.346-0.166-49.162 5.61-73.482 6.195-25.974 41.494-174.362 41.494-174.362s-10.31-20.435-10.31-50.634c0-47.418 27.699-82.845 62.202-82.845 29.338 0 43.491 21.862 43.491 48.048 0 29.254-18.794 73.018-28.477 113.571-8.083 33.936 17.158 61.635 50.906 61.635 61.088 0 102.25-77.869 102.25-170.125 0-70.138-47.606-122.618-134.192-122.618-97.818 0-158.758 72.387-158.758 153.238 0 27.888 8.272 47.542 21.251 62.768 5.965 6.992 6.803 9.808 4.64 17.83-1.552 5.878-5.101 20.054-6.573 25.683-2.141 8.106-8.755 11.002-16.147 8-45.047-18.25-66.047-67.222-66.047-122.262 0-90.909 77.26-199.901 230.476-199.901 123.123 0 204.144 88.41 204.144 183.309 0 125.539-70.33 219.306-173.987 219.306-34.819 0-67.558-18.669-78.771-39.878 0 0-18.733 73.731-22.682 87.968-6.822 24.675-20.221 49.331-32.464 68.544 29.002 8.506 59.638 13.126 91.392 13.126 178.080 0 322.458-143.264 322.458-320s-144.397-320-322.458-320c-178.080 0-322.478 143.242-322.478 319.978z"
      />
    </svg>
  );
}

export { IconPinterest };
